/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './treatment-assessment.reducer';

export const TreatmentAssessmentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const treatmentAssessmentEntity = useAppSelector(state => state.treatmentAssessment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="treatmentAssessmentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.treatmentAssessment.detail.title">TreatmentAssessment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.treatmentAssessment.id">Id</Translate>
            </span>
          </dt>
          <dd>{treatmentAssessmentEntity.id}</dd>
          <dt>
            <span id="assessmentDate">
              <Translate contentKey="tinyMedicRestApp.treatmentAssessment.assessmentDate">Assessment Date</Translate>
            </span>
          </dt>
          <dd>{treatmentAssessmentEntity.assessmentDate}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.treatmentAssessment.active">Active</Translate>
            </span>
          </dt>
          <dd>{treatmentAssessmentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.treatmentAssessment.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{treatmentAssessmentEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.treatmentAssessment.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{treatmentAssessmentEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.treatmentAssessment.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{treatmentAssessmentEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.treatmentAssessment.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{treatmentAssessmentEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentAssessment.plan">Plan</Translate>
          </dt>
          <dd>{treatmentAssessmentEntity.plan ? treatmentAssessmentEntity.plan.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentAssessment.cycle">Cycle</Translate>
          </dt>
          <dd>{treatmentAssessmentEntity.cycle ? treatmentAssessmentEntity.cycle.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentAssessment.assessmentType">Assessment Type</Translate>
          </dt>
          <dd>{treatmentAssessmentEntity.assessmentType ? treatmentAssessmentEntity.assessmentType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentAssessment.assessmentResult">Assessment Result</Translate>
          </dt>
          <dd>{treatmentAssessmentEntity.assessmentResult ? treatmentAssessmentEntity.assessmentResult.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/treatment-assessment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/treatment-assessment/${treatmentAssessmentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TreatmentAssessmentDetail;
